package app.nestbridge.feature.invitations.screen

import com.karawek.core.circuit.Parcelize
import app.nestbridge.feature.invitations.model.Invitation
import com.slack.circuit.runtime.CircuitUiState
import com.slack.circuit.runtime.screen.Screen

@Parcelize
data class ShowInvitationQRCodeScreen(
    val invitationId: String,
) : Screen

data class ShowInvitationQRCodeState(
    val invitation: Invitation,
    val isLoading: Boolean,
    val eventSink: (ShowInvitationQRCodeEvent) -> Unit,
) : CircuitUiState

sealed interface ShowInvitationQRCodeEvent {
    data object OnAppear : ShowInvitationQRCodeEvent
    data object Done : ShowInvitationQRCodeEvent
}
